/** @deprecated Use `BREAKPOINTS` from `@/ui-kit/constants` instead */
export const BREAKPOINTS = {
  xs: "620px",
  sm: "768px",
  md: "1024px",
  retina: "1200px",
  lg: "1280px",
  xl: "1440px",
  "2xl": "1680px",
} as const;

/** @deprecated Use `BreakpointsType` from `@/ui-kit/constants` instead */
export type BreakpointsType = keyof typeof BREAKPOINTS;
